import { Base2Presenter } from "core/presenter";

class ViewDocumentButtonPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      document: {
        visible: false,
        blob: null,
        name: null
      }
    };
  }

  async onRequestDocument() {
    const { repository, document, repositoryFunction } = this.props;

    this.enqueue({ loading: true });

    let documentResult;

    if (repositoryFunction) {
      documentResult = await repository[repositoryFunction](document.uuid);
    } else {
      documentResult = await repository.getDocument(document.uuid);
    }

    if (documentResult.success) {
      this.enqueue(vm => ({
        document: {
          ...vm.document,
          visible: true,
          blob: documentResult.data,
          name: `documento-${document.uuid}`
        }
      }));
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Não conseguimos carregar o documento. Tente novamente mais tarde."
      });
    }

    this.enqueue({ loading: false });
  }

  onHideDocument() {
    this.enqueue(vm => ({
      document: {
        visible: false,
        blob: null
      }
    }));
  }
}

export default ViewDocumentButtonPresenter;



// WEBPACK FOOTER //
// ./src/components/support/view-document-button/presenter.js